import { API_BASE_URL } from './config';

// API service for dashboard data
export const dashboardAPI = {
  // Get aggregated dashboard statistics for all websites
  getDashboardStats: async () => {
    try {
      const token = localStorage.getItem('jwt') || document.cookie.split(';').find(c => c.trim().startsWith('jwt='))?.split('=')[1];
      const response = await fetch(`${API_BASE_URL}/dashboard/stats`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  },

  // Get all websites for the user
  getUserWebsites: async () => {
    try {
      const token = localStorage.getItem('jwt') || document.cookie.split(';').find(c => c.trim().startsWith('jwt='))?.split('=')[1];
      const response = await fetch(`${API_BASE_URL}/user/websites`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching user websites:', error);
      throw error;
    }
  },

  // Get analytics data for all websites
  getAnalytics: async () => {
    try {
      const token = localStorage.getItem('jwt') || document.cookie.split(';').find(c => c.trim().startsWith('jwt='))?.split('=')[1];
      const response = await fetch(`${API_BASE_URL}/dashboard/analytics`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching analytics:', error);
      throw error;
    }
  },
};